import styled, { StyledProps } from 'styled-components'

type StepProps = StyledProps<{
  counter?: string | React.ReactNode
  isActive?: boolean
  isCompleted?: boolean
  isSkiped?: boolean
  dashed?: boolean
  noRightMargin?: boolean
}>

export const StepProgressBarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 1rem;
`

export const StepList = styled.ul`
  display: flex;
  flex-direction: row;
  justify-content: center;

  list-style: none;
`

export const Step = styled.li<StepProps>`
  position: relative;
  margin-right: ${(props) => (props.noRightMargin ? '0' : '7px')};
  width: 300px;
  display: flex;
  flex-direction: column;

  font-family: ${({ theme }) => theme.fonts.bloggerSans};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  font-weight: bold;
  border-radius: 10px;

  border: 2px solid
    ${({ theme, isActive, isCompleted }) => {
      if (isActive) {
        return theme.colors.background
      }

      if (isCompleted) {
        return theme.colors.primary
      }

      return theme.colors.defaultGray
    }};

  font-size: ${({ theme }) => theme.fontSizes.lg};

  color: ${({ theme, isActive, isCompleted }) => {
    if (isActive) {
      return theme.colors.primary
    }

    if (isCompleted) {
      return theme.colors.white
    }

    return '#3C3C3C'
  }};

  background-color: ${({ theme, isActive, isCompleted }) => {
    if (isActive) {
      return theme.colors.background
    }

    if (isCompleted) {
      return theme.colors.primary
    }

    return theme.colors.defaultGray
  }};

  transition: 0.3s;
  padding: 15px;
  text-align: left;

  .step-title {
    font-family: ${({ theme }) => theme.fonts.bloggerSans} !important;
    font-weight: 500;
    font-size: 14px;
    line-height: 13px;
    letter-spacing: 0.4px;
    margin-bottom: 15px;
  }

  .step-descr {
    font-family: ${({ theme }) => theme.fonts.bloggerSans} !important;
    font-weight: 500;
    font-size: 14px;
    line-height: 13px;
    letter-spacing: 0.4px;
  }

  /* make the line */
  &::after {
    content: '';

    z-index: -1;
    position: absolute;
    left: 0;
    top: calc(
      ${({ theme }) =>
        `(${theme.spacings[16]} + ${theme.spacings[2]}) / 2 - 4px`}
    );

    width: 100%;
    height: 2px;

    background: transparent
    transition: 0.3s;
  }

  &:first-of-type::after {
    width: 50%;
    left: 50%;

    background: transparent;
  }

  &:last-of-type::after {
    width: 50%;
    left: 0;

    background: transparent;
  }
`
